<template>
    <div>
        <v-chip @click="showImage(id)" color="yellow" small class="mr-2 mb-2">
            <viewer
                :images="data"
                :class="'viewer' + id"
                :id="'viewer' + id"
                ref="viewer"
                @inited="inited"
            >
                <img
                    v-for="(row, i) in data"
                    :src="showpic + row.file_id"
                    :key="i"
                    class="image"
                />
            </viewer>
            <v-avatar left> <v-icon small>mdi-file-image</v-icon> </v-avatar>
            {{ title }}
        </v-chip>
    </div>
</template>
<script>
import Viewer from "v-viewer/src/component.vue"

export default {
    components: {
        Viewer,
    },
    props: ["id", "data", "title"],
    data() {
        return {
            view: [],
            showpic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
        }
    },
    mounted() {
        this.title = this.title === undefined ? "View Image" : this.title
    },
    methods: {
        inited(viewer) {
            this.view.push(viewer)
        },
        showImage(id) {
            this.view.map((each) => {
                if (each.element.id == "viewer" + id) {
                    this.$viewer = each
                    this.$viewer.show()
                }
            })
        },
    },
}
</script>
<style scoped>
.image {
    display: none;
}
</style>
